/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from "@atproto/lex";

const $nsid = "com.atproto.repo.listRecords";

export { $nsid };

export const $params = /*#__PURE__*/ l.params({"repo":/*#__PURE__*/ l.string({"format":"at-identifier"}),"limit":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.withDefault(/*#__PURE__*/ l.integer({"maximum":100,"minimum":1}), 50)),"cursor":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),"reverse":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.boolean()),"collection":/*#__PURE__*/ l.string({"format":"nsid"})});

export type $Params = l.InferOutput<typeof $params>;

export const $output = /*#__PURE__*/ l.jsonPayload({"cursor":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),"records":/*#__PURE__*/ l.array(/*#__PURE__*/ l.ref<Record$0>((() => record$0) as any), )});

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>;
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<typeof $output, B>;

/** List a range of records in a repository, matching a specific collection. Does not require auth. */
const main = /*#__PURE__*/ l.query($nsid, $params, $output);

export { main };

export const $lxm = $nsid;

type Record$0 = { $type?: "com.atproto.repo.listRecords#record";"cid":l.CidString;"uri":l.AtUriString;"value":l.LexMap };

export type { Record$0 as Record };

const record$0 = /*#__PURE__*/ l.typedObject<Record$0>($nsid, "record", /*#__PURE__*/ l.object({"cid":/*#__PURE__*/ l.string({"format":"cid"}),"uri":/*#__PURE__*/ l.string({"format":"at-uri"}),"value":/*#__PURE__*/ l.lexMap()}));

export { record$0 as record };
